import { InstructionalFeature } from "./InstructionalFeature.component";

export { InstructionalFeature };
